import sv from 'date-fns/locale/sv';
import nb from 'date-fns/locale/nb';
import da from 'date-fns/locale/da';
import fi from 'date-fns/locale/fi';
import format from 'date-fns/format';

const getLocale = (siteId) => {
  switch (parseInt(siteId, 10)) {
    case 1:
      return sv;
    case 3:
      return nb;
    case 11:
      return da;
    case 15:
      return fi;
    case 18:
      return sv;
    default:
      return sv;
  }
};

const firstLetterUppercase = (word) => word && word.replace(/^.{1}/g, word[0].toUpperCase());

const getMonthName = (monthInt, siteId) => {
  const monthName = getLocale(siteId).localize.month(monthInt, 'MMM');
  return firstLetterUppercase(monthName);
};

const getMonthNames = (siteId) => {
  const monthNames = [];
  for (let i = 0; i < 12; i += 1) { 
    monthNames.push(getMonthName(i, siteId));
  }
  return monthNames;
};

const getDateFormat = (dateString, siteId, short) => {
  const date = new Date(dateString);
  const locale = getLocale(siteId);

  switch (siteId) {
    case 1:
    case 3:
    case 11:
    case 18:
      if (short) {
        return format(date, 'd MMM yyyy', {'locale': locale});
      }
      return format(date, 'd MMMM yyyy', {'locale': locale});
    case 15:
      return format(date, 'd.M.yyyy', {'locale': locale});
    default:
      return format(date, 'd MMM yyyy', {'locale': locale});
  }
};

const addLeadingZero = (month) => {
  return `0${month}`?.slice(-2);
}

const getParameterDateFormat = (dateStr) => {
  const date = new Date(dateStr);

  return `${date.getFullYear()}${addLeadingZero(date.getMonth() + 1)}${addLeadingZero(date.getDate())}`;
}

// Takes an integer specifying number of months ahead.
// Returns an array of strings, where each string is the year and month in YYYYMM-format,
// for each of the months ahead.
const getYearMonthArrayFromCurrentMonth = (numberOfMonthsAhead) => {
  const months = [];
  const currentDate = new Date();
  const firstDayOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const date = firstDayOfCurrentMonth;

  for (let i = 0; i < numberOfMonthsAhead; i += 1) {
    date.setMonth(date.getMonth() + 1);
    let month = date.getMonth();
    let year = date.getFullYear();
    if (month === 0) {
      month = 12;
      year -= 1;
    }
    const yearMonth = `${year}${(month) > 9 ? '' : '0'}${month}`;
    months.push(yearMonth);
  };

  return months;
}

// Takes an integer specifying the year and month on the YYYYMM-format.
// Returns the year
const getYearFromYearMonthString = (yearAndMonth) => {
  return yearAndMonth.substring(0, 4);
};

const getMonthFromYearMonthString = (yearAndMonth) => {
  return yearAndMonth.substring(4);
};

export {
  getDateFormat,
  getMonthNames,
  addLeadingZero,
  getYearMonthArrayFromCurrentMonth,
  getParameterDateFormat,
  getYearFromYearMonthString,
  getMonthFromYearMonthString,
};
